import React from 'react';

import { Box } from '@mui/material';
import { ContactJsonldTiersReadNoteGroupTimestampableBlameambleGroup } from '@europrocurement/l2d-domain/openApi/ApiTiers';
import { UserAccountDetailsForm } from '../UserAccountDetailsForm';
import { DetailsViewEditButton } from '../DetailsViewEditButton';

export type UserAccountDetailsProps = {
    contact?: ContactJsonldTiersReadNoteGroupTimestampableBlameambleGroup;
    manageAvatar?: React.ReactNode;
};

export const UserAccountDetails: React.FunctionComponent<UserAccountDetailsProps> = function ({
    contact,
    manageAvatar,
}) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'center',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    gap: 4,
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        gap: 4,
                    }}
                >
                    {manageAvatar || null}
                    <Box>
                        <UserAccountDetailsForm contact={contact} />
                    </Box>
                </Box>
                <DetailsViewEditButton
                    label="Demander la modification de mes informations"
                    href="https://www.legal2digital.fr/contactez-nous/?origine=13&demande=infos"
                    openInNewTab
                />
            </Box>
        </Box>
    );
};
